import {createContext, ReactNode, useCallback, useContext, useState} from 'react';
import {BodySiteId, ConditionId} from '@legit-health/ui';
import useModal from '@/shared/hooks/useModal';
import {Encounter} from '@/shared/interfaces/Encounter';
import DiagnosticReportFormModal from './DiagnosticReportFormModal';

export type FormOptions = {
  onSuccess?: () => void;
  encounter?: Encounter | null;
  conditionId?: ConditionId | null;
  bodySiteId?: BodySiteId | null;
};

type ContextType = (values?: FormOptions) => void;

const Context = createContext<ContextType>(() => {});

export function DiagnosticReportFormModalContextProvider({children}: {children: ReactNode}) {
  const [modalProps, setModalProps] = useState<FormOptions>({});
  const modal = useModal(false, () => setModalProps({}));

  const open = useCallback(
    function (values?: FormOptions) {
      if (values) {
        setModalProps(values);
      }
      modal.open();
    },
    [modal]
  );

  function handleSuccess() {
    modal.close();
    modalProps.onSuccess?.();
  }

  return (
    <Context.Provider value={open}>
      <DiagnosticReportFormModal
        modal={modal}
        encounter={modalProps.encounter}
        conditionId={modalProps.conditionId}
        bodySiteId={modalProps.bodySiteId}
        onSuccess={handleSuccess}
      />
      {children}
    </Context.Provider>
  );
}

export function useDiagnosticReportFormModalContext() {
  return useContext(Context);
}
